
<template>
  <div class='log-wrapper'>
    <div class='logo-card'>
      <div class='logo'>
        <img src="../../public/images/58brother logo.png" alt="logo" class='logo'>
      </div>
      <div class="logo-content">
      <el-tabs v-model="activeLog" @tab-click="changeLog" class="tabs" :stretch="true">
        <el-tab-pane label="Sign Up" name="sign" class='tab-pane'>
          <div class="input-group">
            <div class='title'>Email Address</div>
            <el-input placeholder="Enter your email address" type="email" v-model="emailAddress" required v-on:blur="validateEmail"></el-input>
            <div class='warning'>{{ warningEmail }}</div>
          </div>
          <div class="input-group">
            <div class='title'>Choose a Password</div>
            <el-input placeholder="Enter your password (min-length is 6)" type="password" v-model="password" required v-on:blur="validatePass"></el-input>
            <div class='warning'>{{ warningPass }}</div>
          </div>
          <div class="input-group">
            <div class='title'>Verify Password</div>
            <el-input placeholder="Confirm your password" type="password" v-model="rePassword" required v-on:blur="validateConfirm"></el-input>
            <div class='warning'>{{ warningConfirm }}</div>
          </div>
          <!-- <div class='buttons-set'>
            <button type="button" class="el-button el-button--info is-plain" style="width: 85px" @click="$emit('start-over')">Cancel</button>
          </div> -->
        </el-tab-pane>
        <el-tab-pane label="Log In" name="log" class='tab-pane'>
          <div class="input-group">
            <div class='title'>Email Address</div>
            <el-input placeholder="Enter your email address" type="email" v-model="emailAddress" required v-on:blur="validateEmail"></el-input>
            <div class='warning'>{{ warningEmail }}</div>
          </div>
          <div class="input-group">
            <div class='title'>Password</div>
            <el-input placeholder="Enter your password (min-length is 6)" type="password" v-model="password" required v-on:blur="validatePass"></el-input>
            <div class='warning'>{{ warningPass }}</div>
          </div>
          <div class="input-group">
            <a href="/#/forget_password">Forget password?</a>
          </div>
        </el-tab-pane>
      </el-tabs>
      </div>
      <div class='buttons-set'>
        <button type="button" class="el-button el-button--info is-plain" style="width: 85px" @click="$emit('start-over')">Cancel</button>
        <vue-recaptcha ref="recaptcha"
          v-if="activeLog === 'log'"
          @verify="onVerifyLogin"
          sitekey='6Ld_fmoUAAAAADe5Nj0zSlQm19cqGivLTvBInqIu'
          style="width: 100px">
          <button class="el-button el-button--primary">Log In</button>
        </vue-recaptcha>
        <vue-recaptcha ref="recaptcha"
          v-if="activeLog === 'sign'"
          @verify="onVerifySignUp"
          sitekey='6Ld_fmoUAAAAADe5Nj0zSlQm19cqGivLTvBInqIu'>
          <button class="el-button el-button--primary">Sign Up</button>
        </vue-recaptcha>
      </div>
      <div class="loader" v-if="loading">
        <div style="margin: auto">
          <half-circle-spinner
            :animation-duration="4000"
            :size="50"
            color="#ff1d5e"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable handle-callback-err */

import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  name: 'LogAndSign',
  props: ['email'],
  data () {
    return {
      activeLog: 'log',
      emailAddress: this.email,
      password: '',
      rePassword: '',
      warningEmail: '',
      warningPass: '',
      warningConfirm: '',
      loading: false
    }
  },
  methods: {
    changeLog: function (tab, event) {
      if (this.emailAddress === '') {
        this.warningEmail = ''
      }
      if (this.password === '') {
        this.warningPass = ''
      }
      if (this.rePassword === '') {
        this.warningConfirm = ''
      }
      // console.log(tab, event)
    },
    emailInput: function () {
      // console.log()
    },
    validateEmail: function () {
      var re = /\S+@\S+/
      var result = re.test(String(this.emailAddress).toLowerCase())
      if (!result) {
        this.warningEmail = 'Please enter valid email address'
        return
      }
      if (result) {
        this.warningEmail = ''
      }
    },
    validatePass: function () {
      if (this.password === '') {
        this.warningPass = 'Please enter your password'
        return
      }
      if (this.password.length < 6) {
        this.warningPass = 'Minimum 6 characters in length'
        return
      }
      this.warningPass = ''
    },
    validateConfirm: function () {
      if (this.rePassword === '') {
        this.warningConfirm = 'Please verify your password'
        return
      }
      if (this.password !== this.rePassword) {
        this.warningConfirm = 'Password does not match the confirm password'
        return
      }
      this.warningConfirm = ''
    },
    toSign: function () {
      let that = this
      firebase.auth().createUserWithEmailAndPassword(this.emailAddress, this.password).then(user => {
        // console.log('User logged => uid = ', user.user.uid)
        that.cleanUp()
        that.$emit('success-login')
      }).catch(err => {
        // console.log(err.code)
        that.loading = false
        switch (err.code) {
          case 'auth/invalid-email':
            // console.log('auth/invalid-email')
            that.$message({
              message: 'Email address invalid.',
              center: true,
              type: 'error'
            })
            break
          case 'auth/email-already-in-use':
            that.$message({
              message: 'This email address already in use, please login',
              center: true,
              type: 'error'
            })
            that.activeLog = 'log'
            break
          case 'auth/weak-password':
            that.$message({
              message: 'This password is too weak.',
              center: true,
              type: 'error'
            })
            that.password = ''
            that.rePassword = ''
            break
          default:
            that.$message({
              message: 'Ops! Something is wrong, please refresh.',
              center: true,
              type: 'error'
            })
        }
        that.$refs.recaptcha.reset()
      })
    },
    toLog: function () {
      let that = this
      firebase.auth().signInWithEmailAndPassword(this.emailAddress, this.password).then(user => {
        // console.log('User logged => uid = ', user.user.uid)
        that.cleanUp()
        that.$emit('success-login')
      }).catch(err => {
        // console.log(err.code)
        that.loading = false
        switch (err.code) {
          case 'auth/invalid-email':
            // console.log('auth/invalid-email')
            that.$message({
              message: 'Email address invalid.',
              center: true,
              type: 'error'
            })
            break
          case 'auth/user-disabled':
            that.$message({
              message: 'Your account has been disabled.',
              center: true,
              type: 'error'
            })
            break
          case 'auth/user-not-found':
            that.$message({
              message: 'Account doesn\'t exist.',
              center: true,
              type: 'error'
            })
            that.activeLog = 'sign'
            break
          case 'auth/wrong-password':
            that.$message({
              message: 'Account and password not match.',
              center: true,
              type: 'error'
            })
            that.password = ''
            break
          default:
            that.$message({
              message: 'Ops! Something is wrong, please refresh.',
              center: true,
              type: 'error'
            })
        }
        that.$refs.recaptcha.reset()
      })
    },
    toReset: function () {
      firebase.auth().sendPasswordResetEmail().then(() => {
        // console.log('Email Sent')
      }).catch(err => {
        // console.log(err)
      })
    },
    onVerifyLogin: function (response) {
      let that = this
      if (this.password.length < 6) {
        that.$refs.recaptcha.reset()
        return
      }
      that.loading = true
      // console.log('Verify: ' + response)
      // Verify the token
      axios({
        method: 'post',
        url: 'https://us-central1-yunda-copy-v1-2021-2-4.cloudfunctions.net/reCAPTCHA',
        data: {
          token: response
        }
      }).then(function (res) {
        // console.log(res.data)
        if (res.data === 'success') {
          // do the login
          that.toLog()
        } else {
          // reCAPTCHA Fail
        }
      })
    },
    onVerifySignUp: function (response) {
      let that = this
      if (this.password.length < 6) {
        that.$refs.recaptcha.reset()
        return
      }
      that.loading = true
      // console.log('Verify: ' + response)
      // Verify the token
      axios({
        method: 'post',
        url: 'https://us-central1-yunda-copy-v1-2021-2-4.cloudfunctions.net/reCAPTCHA',
        data: {
          token: response
        }
      }).then(function (res) {
        // console.log(res.data)
        if (res.data === 'success') {
          // do the login
          that.toSign()
        } else {
          // reCAPTCHA Fail
        }
      })
    },
    cleanUp: function () {
      this.activeLog = 'sign'
      this.emailAddress = ''
      this.password = ''
      this.rePassword = ''
      this.warningEmail = ''
      this.warningPass = ''
      this.warningConfirm = ''
      this.loading = false
    }
  },
  components: {
    VueRecaptcha, HalfCircleSpinner
  }
}
</script>

<style>
input {
  margin-bottom: 0;
}
.tabs {
  padding-top: 32px;
  width: 400px;
  margin: auto;
}
.log-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #494949;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.logo-card {
  position: relative;
  width: 500px;
  height: 75vh;
  margin: auto;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 4px 4px 8px 0px #424242;
  box-sizing: border-box;
  padding: 56px 20px 72px 20px;
}
.logo-content {
  overflow-y: auto;
  padding-bottom: 2rem;
  height: auto
}
.logo {
  width:60px;
  margin: auto;
}
/* .el-tabs__item {
  width: 200px;
  font-size: 16px;
  color: #a0a0a0;
  transition: ease 0.4s all;
} */
.el-tabs__item.is-active {
  font-weight: bold;
  color: #494949;
}
.input-group {
  width: 400px;
  margin: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}
.title {
  color: #a0a0a0;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 8px;
}
.buttons-set {
  position: absolute;
  left: 50px;
  right: 50px;
  bottom: 20px;
  background-color: #ffffff;
  padding-top: 20px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.warning {
  color: #f56c6c;
  font-size: 10pt;
  margin-bottom: 1rem
}
.loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(256, 256, 256, 0.7);
  display: flex;
  align-items: center;
}
@media (max-width: 1366px) {
  .logo-card {
    position: relative;
    width: 500px;
    height: 75vh;
    margin: auto;
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 4px 4px 8px 0px #424242;
    box-sizing: border-box;
    padding: 48px 20px 32px 20px;
  }
  .logo {
    width: 60px;
    margin: auto;
  }
  .logo-content {
    overflow-y: auto;
    padding-bottom: 2rem;
    height: 70%;
  }
  /* .el-tabs__nav {
    width: 50%;
  } */
  /* .el-tabs__item {
    width: 100%;
    font-size: 16px;
    color: #aaaaaa;
    transition: ease 0.4s all;
  }
  .el-tabs__nav-prev {
    display: none;
  }
  .el-tabs__nav-next {
    display: none;
  } */
}
@media (max-width: 767px) {
  .logo-card {
    position: relative;
    width: 86%;
    height: 80vh;
    margin: auto;
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 4px 4px 8px 0px #424242;
    box-sizing: border-box;
    padding: 32px 12px 30px 12px;
  }
  .logo {
    width: 50px;
    margin: auto;
  }
  .logo-content {
    overflow-y: auto;
    padding-bottom: 2rem;
    height: 80%
  }
  /* .el-tabs__nav {
    width: 50%;
  } */
  /* .el-tabs__item {
    width: 100%;
    font-size: 16px;
    color: #aaaaaa;
    transition: ease 0.4s all;
  }
  .el-tabs__nav-prev {
    display: none;
  }
  .el-tabs__nav-next {
    display: none;
  } */
  .input-group {
    width: 100%;
    margin: auto;
    padding-top: 12px;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
  }
  .tabs {
    padding-top: 16px;
    width: 100%;
    margin: auto;
  }
  .buttons-set {
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 20px;
    background-color: #ffffff;
    padding-top: 12px;
    text-align: right;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
